import moment from 'moment-timezone'
import { statuses } from '../constants.json'
import { getFileExtension } from '../redux/clinicPatient/sagas'
import { convertTimeOffset, convertTime } from '../redux/profile/actions'

// const formattingFunctions = {}

export const arrayDivideIntoChunk = (array, size) => {
  if (!array) return []
  const firstChunk = array.slice(0, size) // create the first chunk of the given array
  if (!firstChunk.length) {
    return array // this is the base case to terminal the recursive
  }
  return [firstChunk].concat(arrayDivideIntoChunk(array.slice(size, array.length), size))
}

export const formatTrendsForPatientReport = (trendsData, date) => {
  date = moment(date, 'YYYY-MM-DD')

  const trendsMinMaxAvg = Object.keys(trendsData).map((key) => {
    const tmp = []
    const monthTmp = []
    trendsData[key].map((datum) => {
      const momentDate = moment(datum.date, 'YYYY-MM-DD')
      const weekFirst = moment().day('Monday').week(date.week())
      const weekLast = moment().day('Sunday').week(date.week())
      if (
        momentDate.isBetween(weekFirst, weekLast) ||
        momentDate.format('YYYY-MM-DD') === weekFirst.format('YYYY-MM-DD') ||
        momentDate.format('YYYY-MM-DD') === weekLast.format('YYYY-MM-DD')
      ) {
        tmp.push(datum)
      }
      if (momentDate.diff(weekFirst, 'day') > -31 && momentDate.diff(weekFirst, 'day') < 0) {
        monthTmp.push(datum)
      }
      return true
    })
    return formatDataByKey(key, tmp, monthTmp)
  })
  return trendsMinMaxAvg.filter((datum) => Object.keys(datum).length > 0)
}

const formatDataByKey = (key, data, monthData) => {
  if (key === 'bedTime' || key === 'wakeTime') {
    data = data.map((datum) => moment(datum.value, 'YYYY-MM-DD HH:mm:ss').format('HH:mm:ss'))
    monthData = monthData.map((datum) =>
      moment(datum.value, 'YYYY-MM-DD HH:mm:ss').format('HH:mm:ss'),
    )
    return {
      metric: key === 'bedTime' ? 'Bed Time [time]' : 'Wake Time [time]',
      target: '-',
      ...getTimeMinMaxAvg(data),
      monthAvg: getTimeMinMaxAvg(monthData).avg,
    }
  }
  if (key === 'sleep_efficiency') {
    return {
      metric: 'Sleep Efficiency [%]',
      target: '> 85%',
      ...getNumberMinMaxAvg(data.map((datum) => datum.value)),
      monthAvg: getNumberMinMaxAvg(monthData.map((datum) => datum.value)).avg,
    }
  }
  if (key === 'time_to_fall_asleep') {
    return {
      metric: 'Sleep Onset Latency [minutes]',
      target: '15-20min',
      ...getNumberMinMaxAvg(data.map((datum) => datum.value)),
      monthAvg: getNumberMinMaxAvg(monthData.map((datum) => datum.value)).avg,
    }
  }
  if (key === 'waso') {
    return {
      metric: 'Wake After Sleep Onset [minutes]',
      target: '< 30 mins',
      ...getNumberMinMaxAvg(data.map((datum) => datum.value)),
      monthAvg: getNumberMinMaxAvg(monthData.map((datum) => datum.value)).avg,
    }
  }
  if (key === 'total_sleep_time') {
    return {
      metric: 'Total Sleep Time [hours]',
      target: '7 - 9 h',
      ...getNumberMinMaxAvg(data.map((datum) => datum.value)),
      monthAvg: getNumberMinMaxAvg(monthData.map((datum) => datum.value)).avg,
    }
  }
  return {}
}

const getNumberMinMaxAvg = (data) => {
  data = data.filter((datum) => datum)
  return {
    avg: (data.map((datum) => parseFloat(datum)).reduce((a, b) => b + a, 0) / data.length).toFixed(
      1,
    ),
    min: Math.min(...data).toFixed(1),
    max: Math.max(...data).toFixed(1),
  }
}

const getTimeMinMaxAvg = (data) => {
  data = data
    .filter((datum) => datum !== 'Invalid date')
    .map((datum) => timeToDecimal(datum).toFixed(2))

  return {
    avg: decimalToTime(data.reduce((a, datum) => a + parseFloat(datum), 0) / data.length),
    min: decimalToTime(Math.max(...data)),
    max: decimalToTime(Math.min(...data)),
  }
}

const timeToDecimal = (time) => {
  const hoursMinutes = time.split(/[.:]/)
  const hours = parseInt(hoursMinutes[0], 10)
  const minutes = hoursMinutes[1] ? parseInt(hoursMinutes[1], 10) : 0
  const seconds = hoursMinutes[2] ? parseInt(hoursMinutes[2], 10) : 0
  return hours + minutes / 60 + seconds / 3600
}

function decimalToTime(decimalTime) {
  decimalTime = decimalTime * 60 * 60
  let hours = Math.floor(decimalTime / (60 * 60))
  decimalTime -= hours * 60 * 60
  let minutes = Math.floor(decimalTime / 60)
  decimalTime -= minutes * 60
  let seconds = Math.round(decimalTime)
  if (hours < 10) {
    hours = `0${hours}`
  }
  if (minutes < 10) {
    minutes = `0${minutes}`
  }
  if (seconds < 10) {
    seconds = `0${seconds}`
  }
  return `${hours}:${minutes}`
}

// function to generate status from sleepSessions status numbaric value to readable text
export const generateStatus = (status) => {
  let data
  if (status === 0) {
    data = 'Sleep On'
  } else if (status === 1) {
    data = 'Valid'
  } else if (status === 2) {
    data = 'In-valid'
  } else if (status === 3) {
    data = 'Missing data'
  } else if (status === 4) {
    data = 'Duplicate'
  }

  return data
}

export const formatMemberType = (value, isAppUser) => {
  let memberType = value
  if (value === 'member') memberType = 'Member'

  if (value === 'cip_users') memberType = 'Web Portal External Member/CIP User'

  if (value === 'vc-admin') memberType = 'Provider'

  if (value === 'sa') memberType = 'Superadmin'

  if (value === 'clinical-triage') memberType = 'Triage User'

  if (value === 'home_health_patient') memberType = 'Home Health Patient'

  if (value === 'clinic') {
    if (isAppUser && value !== 'cip_users') {
      memberType = 'Pro App Member'
    } else {
      memberType = 'Web Portal Member'
    }
  }

  return memberType
}

export const convertMinsToNumberOfHours = (mins) => {
  /* eslint-disable */
  let formatedTimeInBed
  if (mins > 0) {
    const hour = Math.floor(mins / 60)
    let m = Math.floor(mins % 60)
    m = m < 10 ? '0' + m : m
    formatedTimeInBed = `${hour}h ${m}m`
  }
  /* eslint-enable */
  return formatedTimeInBed
}

// This function is to convert minutes into hours and minutes return formate will be 3h 20m
export const convertMinsToHrsMins = (mins) => {
  // do not include the first validation check if you want, for example,
  // getTimeFromMins(1530) to equal getTimeFromMins(90) (i.e. mins rollover)

  if (mins >= 24 * 60 || mins < 0) {
    throw new RangeError('Valid input should be greater than or equal to 0 and less than 1440.')
  }
  const h = (mins / 60) | 0 // eslint-disable-line no-bitwise
  const m = mins % 60 | 0 // eslint-disable-line no-bitwise

  if (mins === 0) {
    return '0'
  }
  if (h === 0) {
    return `0h ${moment.utc().minutes(m).format('mm[m]')}`
  }
  return moment.utc().hours(h).minutes(m).format('h[h] mm[m]')
}

export function removeDuplicateObjects(arr, comp) {
  const unique = arr
    .map((e) => e[comp])

    // store the keys of the unique objects
    .map((e, i, final) => final.indexOf(e) === i && i)

    // eliminate the dead keys & store unique objects
    .filter((e) => arr[e])
    .map((e) => arr[e])

  return unique
}

export const bulletColor = (range, max, min) => {
  let color = '#05a45b'
  if (range >= max || range < min) {
    color = '#c23f3f'
  }
  return color
}

export const generateThresholdRanges = (valueAxis, thresholdMax, thresholdMin, am4core) => {
  const range = valueAxis.axisRanges.create()
  range.value = thresholdMax
  range.grid.stroke = am4core.color('#c23f3f')
  range.grid.strokeWidth = 2
  range.grid.strokeOpacity = 1
  range.label.inside = true
  range.label.text = `${thresholdMax} BrPM`
  range.label.fill = range.grid.stroke
  range.grid.strokeDasharray = 6
  range.label.verticalCenter = 'bottom'

  const range2 = valueAxis.axisRanges.create()
  range2.value = thresholdMin
  range2.grid.stroke = am4core.color('#c23f3f')
  range2.grid.strokeWidth = 2
  range2.grid.strokeOpacity = 1
  range2.grid.strokeDasharray = 6
  range2.label.inside = true
  range2.label.text = `${thresholdMin} BrPM`
  range2.label.fill = range2.grid.stroke
  range2.label.verticalCenter = 'bottom'
  return true
}

export const getoffSet = (dateTime, format = 'MM/DD/YYYY HH:mm:ss') => {
  const offset = new Date().getTimezoneOffset()
  let offsetToCal = offset / 60
  if (offset < 0) {
    offsetToCal = offset / -60
  }
  return convertTimeOffset(dateTime, offsetToCal, format)
}

export const getBrowserOffSet = () => {
  const offset = new Date().getTimezoneOffset()
  let offsetToCal = offset / 60
  if (offset < 0) {
    offsetToCal = offset / -60
  }
  return offsetToCal
}

export const formatBoxData = (dataArr, returnType) => {
  let result = 0
  if (dataArr.length > 0) {
    if (returnType === 'min') {
      const min = dataArr.filter((val) => val.min_rr).map((val) => val.min_rr)
      result = Math.min(...min).toFixed(2)
    } else if (returnType === 'max') {
      const max = dataArr.filter((val) => val.max_rr).map((val) => val.max_rr)
      result = Math.max(...max).toFixed(2)
    } else {
      const avg = dataArr.filter((val) => val.avg_rr).map((val) => val.avg_rr)
      result = (avg.reduce((a, b) => a + b) / avg.length).toFixed(2)
    }
  }
  return result
}

export const checkLastUpdatedRRObject = (deviceObj) => {
  /* eslint-disable */
  const currentTimestamp = parseInt(
    Math.floor((new Date().getTime() + new Date().getTimezoneOffset() * 60 * 1000) / 1000) + '000',
    10,
  )
  const difference = currentTimestamp - new Date(deviceObj.rr_last_mint.tracker_ts).getTime()
  const secondsDifference = Math.floor(difference / 1000)

  /* eslint-enable */

  return secondsDifference
}

export const getCounting = (number) => {
  switch (number) {
    case 1:
      return '1st'
    case 2:
      return '2nd'
    case 3:
      return '3rd'
    default:
      return `${number}th`
  }
}

export const formateTime = (time, timeZone) => {
  const timeInFloating = parseFloat(time)
  const minsFloating = (timeInFloating % 1) * 60
  let mins = Math.trunc(minsFloating)
  let hours = `${time}`.split('.')[0]

  let offset = moment().utcOffset() / 60
  if (timeZone) {
    offset = moment().tz(timeZone).utcOffset() / 60
  }
  hours = parseInt(hours, 10)
  hours += offset
  if (hours >= 24) {
    hours -= 24
  } else if (hours < 0) {
    hours += 24
  }
  mins = mins < 10 ? `0${mins}` : mins
  hours = hours < 10 ? `0${hours}` : hours
  if (hours < 12) {
    hours = hours === '00' ? 12 : hours
    return `${hours}:${mins} AM`
  }
  hours -= 12
  return `${hours}:${mins} PM`
}

export const getCleanFileName = (fileName) => {
  const ext = getFileExtension(fileName)
  const [newfileName] = fileName && fileName !== 'None' ? fileName.split('-') : '-'
  return newfileName.concat(`.${ext}`)
}

export const formatingStringAddLineBreak = (input, lineSize, lineArray) => {
  lineArray = lineArray || []
  if (input.length <= lineSize) {
    lineArray.push(input)
    return lineArray
  }
  lineArray.push(input.substring(0, lineSize))
  const tail = input.substring(lineSize)
  return formatingStringAddLineBreak(tail, lineSize, lineArray)
}

export const getMappedRoom = (item, prevRoom, newRoom, patientDetails, timezone) => {
  const momentTime = moment().utcOffset(0)
  momentTime.set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
  if (prevRoom && !prevRoom.endTime) {
    prevRoom.endTime = moment(
      convertTime(prevRoom.updated_at, timezone, 'YYYY-MM-DD HH:mm:ss'),
      'YYYY-MM-DD HH:mm:ss',
    )
  }
  if (prevRoom && !prevRoom.endDate) {
    prevRoom.endDate = moment(
      convertTime(prevRoom.updated_at, timezone, 'YYYY-MM-DD HH:mm:ss'),
      'YYYY-MM-DD HH:mm:ss',
    )
  }

  if (newRoom && !newRoom.startTime) {
    newRoom.startTime = moment(
      convertTime(newRoom.created_at, timezone, 'YYYY-MM-DD HH:mm:ss'),
      'YYYY-MM-DD HH:mm:ss',
    )
  }
  if (newRoom && !newRoom.startDate) {
    newRoom.startDate = moment(
      convertTime(newRoom.created_at, timezone, 'YYYY-MM-DD HH:mm:ss'),
      'YYYY-MM-DD HH:mm:ss',
    )
  }
  let endDateLimitForElse = moment()
  if (patientDetails.date_of_discharge) {
    endDateLimitForElse = moment(patientDetails.date_of_discharge, 'YYYY-MM-DD')
  }
  return {
    id: item.id,
    room: item.name,
    device_id: item.device_id,
    startDate: item.created_at
      ? moment(convertTime(item.created_at, timezone, 'YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss')
      : undefined,
    startTime: item.created_at
      ? moment(convertTime(item.created_at, timezone, 'YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss')
      : undefined,
    endDate: item.updated_at
      ? moment(convertTime(item.updated_at, timezone, 'YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss')
      : undefined,
    endTime: item.updated_at
      ? moment(convertTime(item.updated_at, timezone, 'YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss')
      : undefined,
    startDateLimit:
      prevRoom && prevRoom.endDate
        ? prevRoom.endDate.clone()
        : moment(patientDetails.date_of_admission, 'YYYY-MM-DD'),
    endDateLimit: newRoom && newRoom.startDate ? newRoom.startDate.clone() : endDateLimitForElse,
    startTimeLimit:
      prevRoom && prevRoom.endTime ? prevRoom.endTime.clone().add(1, 'seconds') : momentTime,
    deleted: false,
    isInDatabase: true,
  }
}

export const limitDateOfTransferRoom = (
  date,
  devices,
  currentDeviceObj,
  index,
  patientDetails,
  type,
) => {
  if (type === 'startDate') {
    let returnResult =
      !(date.diff(currentDeviceObj.startDateLimit) > 0 && date.diff(moment()) < 0) ||
      !date.isAfter(moment(patientDetails.date_of_admission).subtract(1, 'days'), 'day')
    if (index > 0) {
      const preEndDate = devices[index - 1].updated_at
      returnResult =
        !(date.diff(preEndDate) > 0 && date.diff(moment()) < 0) ||
        !date.isAfter(moment(patientDetails.date_of_admission).subtract(1, 'days'), 'day')
    }
    return returnResult
  }
  return true
}

export const getNewValidRoomRow = (allRooms, index) => {
  let newRoom = allRooms[index + 1] ? allRooms[index + 1] : {}
  if (newRoom.status === 0) {
    newRoom = getNewValidRoomRow(allRooms, index + 1)
  }
  return newRoom
}

export const updateRecords = (clonedRoomsState, index) => {
  const prevRoom = clonedRoomsState[index - 1] ? clonedRoomsState[index - 1] : {}
  const nextRoom = getNewValidRoomRow(clonedRoomsState, index)

  if (Object.keys(nextRoom).length === 0) {
    prevRoom.endDate = undefined
    prevRoom.endTime = undefined
    return true
  }
  if (Object.keys(prevRoom).length > 0 && Object.keys(nextRoom).length > 0) {
    nextRoom.startDate = prevRoom.endDate.clone()
    nextRoom.startTime = prevRoom.endTime.clone()
    nextRoom.startTime.add(1, 'minutes')
    nextRoom.startDateLimit = prevRoom.endDate.clone()
    nextRoom.startTimeLimit = prevRoom.endTime.clone()
    nextRoom.startTimeLimit.add(1, 'minutes')
    return true
  }
  return true
}

export const capitalize = ([first, ...rest]) => first.toUpperCase() + rest.join('').toLowerCase()

export const formatAbsoluteValue = (value) => {
  let finalValue
  if (value > 0) {
    finalValue = `+${value.toFixed(1)}`
  } else {
    finalValue = value.toFixed(1)
  }
  return finalValue
}

export const getTimezoneOfAnyDevice = (devices) => {
  let newTz
  if (devices.find((item) => item.device_tz).device_tz) {
    newTz = devices.find((item) => item.device_tz).device_tz
  }
  return newTz
}

export const getTimezoneOfAnyDeviceFromPatientsArray = (patients) =>
  patients.find((item) => item.device.device_tz).device.device_tz

export const formatedDateTime = (date, timezone = 'Europe/London') => {
  const m = moment.utc(date) // parse input as UTC
  const newDate = m.tz(timezone).format('MMM Do YYYY HH:mm:ss')
  return newDate
}
export const groupPatientsByFlag = (patientsList) => {
  const tmpStatuses = statuses.reduce((obj, { id, name }) => {
    obj[id] = { name, patients: [] }
    return obj
  }, {})
  return patientsList.reduce((obj, val) => {
    obj[val.flaggedResidentNotes.status].patients.push(val)
    return obj
  }, tmpStatuses)
}

/* eslint-disable */
export const getDaysArrayByMonth = () => {
  let daysInMonth = moment().daysInMonth()
  const arrDays = []

  while (daysInMonth) {
    const current = moment().date(daysInMonth)
    arrDays.push(current)
    daysInMonth--
  }

  return arrDays
}
/* eslint-enable */

export const formatDeviceMetrics = (devices, totalDevices) => {
  const deviceMetrics = devices.reduce(
    (acc, val) => {
      if (!val.device_conn_status) {
        acc.disconnected += 1
      }
      if (val.patient_id) {
        acc.occupied += 1
      }
      return acc
    },
    {
      disconnected: 0,
      occupied: 0,
    },
  )

  deviceMetrics.percentageDisconnected = Math.round(
    (deviceMetrics.disconnected / totalDevices) * 100,
  )
  deviceMetrics.total = totalDevices

  return deviceMetrics
}

export const checkArrayValuesAreNull = (data, key) => !!data && !data.find((i) => i[key])

// export default formattingFunctions
